import { ChartFragment, FileChartData } from 'models/api-response';
import { getContentBaseURL } from 'config/app.config';
import { FILE_NAV_ID, FileKind, IMAGE_EXTENSIONS, PDF_EXTENSIONS } from './constants';

export const isFileFragment = (fragment: ChartFragment): boolean => fragment?.navElementId === FILE_NAV_ID;

const isAbsoluteUrl = (filePath: string): boolean => /^https?:\/\//i.test(filePath);

export const buildFileUrl = (filePath: string | undefined, contentBaseURL: string): string | undefined => {
  if (!filePath) {
    return undefined;
  }
  if (isAbsoluteUrl(filePath)) {
    return filePath;
  }
  // Without a base URL the path would resolve against the app origin and silently 404, so treat it
  // as an unavailable file instead.
  if (!contentBaseURL) {
    return undefined;
  }
  return `${contentBaseURL.replace(/\/+$/, '')}/${filePath.replace(/^\/+/, '')}`;
};

export const getFileUrl = (chartData?: FileChartData): string | undefined => buildFileUrl(chartData?.filePath, getContentBaseURL());

const getExtension = (fileUrl: string): string => {
  const [path] = fileUrl.split('?');
  const fileName = path.substring(path.lastIndexOf('/') + 1);
  const dotIndex = fileName.lastIndexOf('.');
  return dotIndex === -1 ? '' : fileName.substring(dotIndex + 1).toLowerCase();
};

export const getFileKind = (fileUrl?: string): FileKind => {
  if (!fileUrl) {
    return FileKind.UNSUPPORTED;
  }
  const extension = getExtension(fileUrl);
  if (PDF_EXTENSIONS.includes(extension)) {
    return FileKind.PDF;
  }
  if (IMAGE_EXTENSIONS.includes(extension)) {
    return FileKind.IMAGE;
  }
  return FileKind.UNSUPPORTED;
};
